import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit, SecurityContext } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { DetalleUsuarioService } from 'src/app/Services/detalle-usuario.service';
import { ListaEmpresasService } from 'src/app/Services/lista-empresas.service';
import { ParametroAccionService } from 'src/app/Services/parametro-accion.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-cert-ddjj-form',
  templateUrl: './modal-cert-ddjj-form.component.html',
  styleUrls: ['./modal-cert-ddjj-form.component.css']
})
export class ModalCertDdjjFormComponent implements OnInit {
  private certDecJur:string = environment.certdecjur;
  private lovs:string = environment.periodos;
  rutVal:any;
  form: FormGroup;
  aniosLov: any[] = [];

  constructor( private sanitizer:DomSanitizer, public parametroAccionService:ParametroAccionService, private fb: FormBuilder, private http: HttpClient, public detalleUsuarioService : DetalleUsuarioService, private modalService: NgbModal, public listaEmprService : ListaEmpresasService, private router: Router) { 
    /****************Valida sesión con RUT*****************/
        this.detalleUsuarioService.getVariableCompartida().subscribe(datos => {
          this.rutVal = datos;
        });
        if (this.rutVal=="0"||this.rutVal==null) {
          //var urlcierre :string="https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout?https%3A%2F%2Faplicaciones.mop.gob.cl%2FTramitesDCyF";
          //var sanitizedValue:string= this.sanitizer.sanitize(SecurityContext.URL,urlcierre);
          //window.location.href=sanitizedValue;
          this.listaEmprService.limpiarDatos();
          this.detalleUsuarioService.limpiarDatos();
          this.detalleUsuarioService.limpiarRut();
          localStorage.clear();
          this.router.navigate(['/inicio']);
          return;
        }
        /****************Fin Valida sesión con RUT*****************/
        this.form = this.fb.group({
          anio: []
        });
  }

  ngOnInit(): void {
    this.http.post<any>(this.lovs, { 
      rut:this.detalleUsuarioService.obtenerRut(),
    }).subscribe((data:any) => {
      this.aniosLov = data.Resultados;
    }, err => {
      console.log("error capturado");
      console.log(err);
    });
    
  }
  
  GenerarPDF(){
    /*this.parametroAccionService.limpiarDatos();
    this.http.post<any>(this.certDecJur, { 
      rut:this.detalleUsuarioService.obtenerRut(),
      ano:Number(this.form.get('anio').value)
    },{ observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const statusCode = response.status;
      const responseBody = response.body;
      const respuesta = responseBody.Resultados[0];
      //console.log("llamada insert_repr"+respuesta);
      if (statusCode === 200) {
        //resolve(responseBody);
        this.parametroAccionService.guardarDatos(respuesta);
        this.modalService.dismissAll();
        this.router.navigate(['/app-cert-ddjj-vp']);
      }else{
        console.log(respuesta);
        //reject(responseBody);
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
      //reject(err);
      //continuar=false;
    });*/
    this.parametroAccionService.guardarDatos(Number(this.form.get('anio').value));
    this.modalService.dismissAll();
    this.router.navigate(['/cert-ddjj-vp']);
  }
  
  onCloseModal() {
    this.modalService.dismissAll();
  }
}
